import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'

import { Link } from '~/components'
import { useAppSelector } from '~/redux/hooks'
import curriculumAnalytics from '~/analytics/curriculum/curriculumAnalytics'

import { selectGradeListByCountry } from '../slice/curriculum.slice'

export default function CurriculumFooter(): React.ReactElement {
  const { t } = useTranslation('curriculum')
  const router = useRouter()
  const { countryCode, grade } = router.query
  const gradeList = useAppSelector(selectGradeListByCountry)
  const gradeLevel = parseInt(grade as string)

  const prevGradeLabel = gradeList.find((gradeDetails) => gradeDetails.gradeLevel === gradeLevel - 1)?.gradeLabel
  const nextGradeLabel = gradeList.find((gradeDetails) => gradeDetails.gradeLevel === gradeLevel + 1)?.gradeLabel

  const prevGradeUrl = `/curriculum/${countryCode}/${parseInt(grade as string) - 1}`
  const nextGradeUrl = `/curriculum/${countryCode}/${parseInt(grade as string) + 1}`

  const linkClassName =
    'text-white text-center tracking-px bg-purple rounded-2 px-1.5 md:px-4 py-2 border-white border md:hover:scale-110 duration-300'

  return (
    <div className="flex space-x-3 md:space-x-40 justify-center pt-5">
      {prevGradeLabel && (
        <Link
          className={linkClassName}
          onClick={() => curriculumAnalytics.logSwitchCurriculum('previous', parseInt(grade as string))}
          to={prevGradeUrl}
        >
          {t('gotoPrevGrade', { prevGradeLabel })}
        </Link>
      )}
      {nextGradeLabel && (
        <Link
          className={linkClassName}
          onClick={() => curriculumAnalytics.logSwitchCurriculum('next', parseInt(grade as string))}
          to={nextGradeUrl}
        >
          {t('gotoNextGrade', { nextGradeLabel })}
        </Link>
      )}
    </div>
  )
}
